import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { green, black1 } from 'app/components/ThemeProvider/colors';

const CoinsSwapIcon = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 20 20" sx={{ height: '20px', width: '20px', fill: 'transparent', ...sx }} {...props}>
      <g clipPath="url(#clip0_958_5020)">
        <path
          d="M4.99984 4.99984L6.6665 3.33317M6.6665 3.33317L4.99984 1.6665M6.6665 3.33317H4.99984C3.15889 3.33317 1.6665 4.82555 1.6665 6.6665M14.9998 14.9998L13.3332 16.6665M13.3332 16.6665L14.9998 18.3332M13.3332 16.6665H14.9998C16.8408 16.6665 18.3332 15.1741 18.3332 13.3332M11.1808 11.1808C11.8327 11.4922 12.5626 11.6665 13.3332 11.6665C16.0946 11.6665 18.3332 9.42793 18.3332 6.6665C18.3332 3.90508 16.0946 1.6665 13.3332 1.6665C10.5717 1.6665 8.33317 3.90508 8.33317 6.6665C8.33317 7.4371 8.5075 8.16698 8.81886 8.81886M11.6665 13.3332C11.6665 16.0946 9.42793 18.3332 6.6665 18.3332C3.90508 18.3332 1.6665 16.0946 1.6665 13.3332C1.6665 10.5717 3.90508 8.33317 6.6665 8.33317C9.42793 8.33317 11.6665 10.5717 11.6665 13.3332Z"
          stroke={props.color === 'warning' ? green : black1}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_958_5020">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export default CoinsSwapIcon;
